export const SELECTION_PAGE = '/kredity/onlajn-zayavka-na-kredit/';
